import css from './DetailsGeneral.module.css';

function DetailsGeneral({ content, functions }) {
    return (
        <div className={css.general}>
            <h2 className={css.h2}>General</h2>
            <div className={css.details}>
                {content.image && (
                    <div
                        className={css.image}
                        style={{
                            backgroundImage: content.image,
                        }}
                    ></div>
                )}

                <div>
                    {content.info.map((x) => x)}
                    <button className={css.editButon} onClick={functions.edit}>
                        Edit
                    </button>
                </div>
                <div>
                    {content.notes}
                    {content.options}
                </div>
                {content.additional}
            </div>
        </div>
    );
}

export default DetailsGeneral;
